export const CUSTOM_STANDARDS_PRESET_ID = "custom";

export const BUILTIN_STANDARDS_PRESET_IDS = {
    NA_BROADCAST: "builtin-na-broadcast",
    EUROPEAN_TELETEXT: "builtin-european-teletext",
};

export const STANDARDS_FIELDS = [
    "maxCps",
    "maxWpm",
    "maxChars",
    "maxLines",
    "minDuration",
    "maxDuration",
    "overlap",
    "illegalChars",
];

export const NA_BROADCAST_STANDARDS = {
    maxCps: 20,
    maxWpm: 9999,
    maxChars: 32,
    maxLines: 2,
    minDuration: 0.75,
    maxDuration: 12,
    overlap: true,
    illegalChars: true,
};

export const EUROPEAN_TELETEXT_STANDARDS = {
    maxCps: 20,
    maxWpm: 9999,
    maxChars: 37,
    maxLines: 2,
    minDuration: 1,
    maxDuration: 7,
    overlap: true,
    illegalChars: false,
};

export const BUILTIN_STANDARDS_PRESETS = [
    {
        id: BUILTIN_STANDARDS_PRESET_IDS.NA_BROADCAST,
        builtin: true,
        type: "event-group-standards",
        config: { ...NA_BROADCAST_STANDARDS },
    },
    {
        id: BUILTIN_STANDARDS_PRESET_IDS.EUROPEAN_TELETEXT,
        builtin: true,
        type: "event-group-standards",
        config: { ...EUROPEAN_TELETEXT_STANDARDS },
    },
];

export function normalizeStandardsConfig(config = {}) {
    return {
        maxCps: Number(config.maxCps),
        maxWpm: Number(config.maxWpm),
        maxChars: Number(config.maxChars),
        maxLines: Number(config.maxLines),
        minDuration: Number(config.minDuration),
        maxDuration: Number(config.maxDuration),
        overlap: Boolean(config.overlap),
        illegalChars: Boolean(config.illegalChars),
    };
}

export function standardsConfigsEqual(a, b) {
    const left = normalizeStandardsConfig(a);
    const right = normalizeStandardsConfig(b);

    return STANDARDS_FIELDS.every((key) => left[key] === right[key]);
}

export function findMatchingStandardsPreset(config, presets = []) {
    return presets.find((preset) => standardsConfigsEqual(preset.config, config)) || null;
}

export function isBuiltinStandardsPreset(presetOrId) {
    if (!presetOrId) {
        return false;
    }

    const id = typeof presetOrId === "string" ? presetOrId : presetOrId.id;
    return Object.values(BUILTIN_STANDARDS_PRESET_IDS).includes(id);
}
